import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col col-12" }
const _hoisted_2 = { class: "row py-3 g-0" }
const _hoisted_3 = { class: "col-12 px-4 col-md-12 g-0" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "form-group col-12 ps-0" }
const _hoisted_6 = {
  class: "d-flex flex-column px-4 py-2",
  slot: "content"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_9 = { class: "me-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "row col-12" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-first-name-add" }, " First Name ", -1 /* HOISTED */)
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-last-name-add" }, " Last Name ", -1 /* HOISTED */)
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-relationship-add" }, " Relationship ", -1 /* HOISTED */)
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-rel-desc" }, " Other ", -1 /* HOISTED */)
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-email-add" }, " Email ", -1 /* HOISTED */)
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { for: "referral-mobile-number-add" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Mobile Phone ")
const _hoisted_34 = { class: "fas fa-question-circle" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-phone-add" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "Representative", -1 /* HOISTED */)
const _hoisted_41 = { class: "form-check custom-checkbox" }
const _hoisted_42 = ["id", "checked", "onUpdate:modelValue"]
const _hoisted_43 = ["for"]
const _hoisted_44 = { class: "form-check custom-checkbox" }
const _hoisted_45 = ["id", "checked", "onUpdate:modelValue"]
const _hoisted_46 = ["for"]
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = { class: "col-12 form-group d-flex" }
const _hoisted_49 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_50 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_51 = ["for"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Patient Address", -1 /* HOISTED */)
const _hoisted_53 = [
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Additional Emergency Contact",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referral.Contacts.AdditionalEmergencyContacts, (contact, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${index}`
                  }, [
                    _createVNode(_component_FormSection, {
                      "application-id": _ctx.application,
                      showBackground: false,
                      class: "mt-1"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h6", _hoisted_8, [
                              _createElementVNode("b", _hoisted_9, "Additional Emergency Contact " + _toDisplayString(index + 1), 1 /* TEXT */),
                              _createElementVNode("button", {
                                class: "btn table-btn btn-outline-danger me-1 ms-auto",
                                onClick: ($event: any) => (_ctx.removeEmergencyContact(index))
                              }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _withDirectives(_createElementVNode("input", {
                                  name: "auth-contact-first-name-add",
                                  class: "form-control",
                                  maxlength: "50",
                                  type: "text",
                                  placeholder: "Enter First Name",
                                  "onUpdate:modelValue": ($event: any) => ((contact.FirstName) = $event)
                                }, null, 8 /* PROPS */, _hoisted_17), [
                                  [_vModelText, contact.FirstName]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _withDirectives(_createElementVNode("input", {
                                  name: "auth-contact-last-name-add",
                                  class: "form-control",
                                  maxlength: "50",
                                  type: "text",
                                  placeholder: "Enter Last Name",
                                  "onUpdate:modelValue": ($event: any) => ((contact.LastName) = $event)
                                }, null, 8 /* PROPS */, _hoisted_20), [
                                  [_vModelText, contact.LastName]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select",
                                  name: "auth-contact-relationship-add",
                                  "onUpdate:modelValue": ($event: any) => ((contact.RelationOption) = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.relation, (relation, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: index,
                                      value: relation.value
                                    }, _toDisplayString(relation.text), 9 /* TEXT, PROPS */, _hoisted_24))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_23), [
                                  [_vModelSelect, contact.RelationOption]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _withDirectives(_createElementVNode("input", {
                                  name: "auth-contact-rel-desc",
                                  class: "form-control",
                                  type: "text",
                                  placeholder: "Enter Relationship",
                                  "onUpdate:modelValue": ($event: any) => ((contact.Relationship) = $event)
                                }, null, 8 /* PROPS */, _hoisted_27), [
                                  [_vModelText, contact.Relationship]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _withDirectives(_createElementVNode("input", {
                                  name: "auth-contact-email-add",
                                  class: "form-control",
                                  maxlength: "50",
                                  type: "text",
                                  placeholder: "Enter Email",
                                  "onUpdate:modelValue": ($event: any) => ((contact.EmailAddress) = $event)
                                }, null, 8 /* PROPS */, _hoisted_30), [
                                  [_vModelText, contact.EmailAddress]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("label", _hoisted_32, [
                                  _hoisted_33,
                                  _withDirectives(_createElementVNode("i", _hoisted_34, null, 512 /* NEED_PATCH */), [
                                    [_directive_tooltip, {
                                                                        title: 'For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.'
                                                                    }]
                                  ])
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  name: "referral-mobile-number-add",
                                  type: "text",
                                  class: "form-control phone-number-input",
                                  maxlength: "10",
                                  placeholder: "Enter Number",
                                  "onUpdate:modelValue": ($event: any) => ((contact.PrimaryPhone) = $event)
                                }, null, 8 /* PROPS */, _hoisted_35), [
                                  [_directive_number_only],
                                  [_vModelText, contact.PrimaryPhone]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _withDirectives(_createElementVNode("input", {
                                  name: "referral-alternate-phone-add",
                                  type: "text",
                                  class: "form-control phone-number-input",
                                  maxlength: "10",
                                  placeholder: "Enter Number",
                                  "onUpdate:modelValue": ($event: any) => ((contact.AlternatePhone) = $event)
                                }, null, 8 /* PROPS */, _hoisted_38), [
                                  [_directive_number_only],
                                  [_vModelText, contact.AlternatePhone]
                                ])
                              ]),
                              _hoisted_39,
                              _createElementVNode("div", null, [
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    id: `Additional-Legal-Representative-${index}`,
                                    value: 1,
                                    checked: contact.Representative === 1,
                                    "onUpdate:modelValue": ($event: any) => ((contact.Representative) = $event)
                                  }, null, 8 /* PROPS */, _hoisted_42), [
                                    [_vModelCheckbox, contact.Representative]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: `Additional-Legal-Representative-${index}`
                                  }, " Legal Representative ", 8 /* PROPS */, _hoisted_43)
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    id: `Additional-Patient-Selected-Representative-${index}`,
                                    value: 2,
                                    checked: contact.Representative === 2,
                                    "onUpdate:modelValue": ($event: any) => ((contact.Representative) = $event)
                                  }, null, 8 /* PROPS */, _hoisted_45), [
                                    [_vModelCheckbox, contact.Representative]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: `Additional-Patient-Selected-Representative-${index}`
                                  }, " Patient Selected Representative ", 8 /* PROPS */, _hoisted_46)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: `same-patient-addr-add-${index}`,
                                    class: "form-check-input au-target",
                                    "onUpdate:modelValue": ($event: any) => ((contact.SameAsPatientAddress) = $event),
                                    onChange: ($event: any) => (_ctx.makeEmergencyAsPrimary(contact, index))
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_50), [
                                    [_vModelCheckbox, contact.SameAsPatientAddress]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: `same-patient-addr-add-${index}`
                                  }, _hoisted_53, 8 /* PROPS */, _hoisted_51)
                                ])
                              ]),
                              _createVNode(_component_ReferralAddressForm, {
                                index: index,
                                address: contact.Address,
                                showZipFourCode: false,
                                addressType: `AdditionalEmergencyContacts${index}`,
                                zipChanged: _ctx.handleZipChange,
                                "county-data": 
                                                                index === 0
                                                                    ? _ctx.additional1
                                                                    : index === 1
                                                                    ? _ctx.additional2
                                                                    : _ctx.additional3
                                                            
                              }, null, 8 /* PROPS */, ["index", "address", "addressType", "zipChanged", "county-data"])
                            ])
                          ])
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["application-id"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("button", {
                class: "btn btn-xs btn-primary mb-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEmergencyContact()))
              }, " + Add Emergency Contact ")
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}